import { notification } from 'antd';
import CustomImage from '../Antd/Image';
import { Notification } from './constant';

export const CustomNotification = ({ type, message, description }) => {
	return notification[type]({
		message: message,
		description: description,
		icon: (
			<CustomImage
				src={`https://storage.googleapis.com/tirx-resources-production/${
					type === Notification.type.success ? '61e47f3d-bff8-41ab-a321-c25e04b956cd' : '5ba15053-cc87-478e-84fa-bd74b905c067'
				}.png`}
				alt="notification icon"
				width={24}
			/>
		),
	});
};
